var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-icon"},[_c('i',{staticClass:"material-symbols-outlined info"},[_vm._v("info_i")])])
}]

export { render, staticRenderFns }